import { AreasActions } from './../actions/areas.actions';
import { tassign } from 'tassign';
import { RidangoReduxAction, Area } from '@ridango/core';



export interface AreasState {
    all: Area[];
    selected: Area;
}
export const AREAS_INITIAL_STATE: AreasState = {
    all: [],
    selected: null
};

export function areasReducer ( lastState: AreasState = AREAS_INITIAL_STATE, action: RidangoReduxAction ): AreasState {
    switch ( action.type ) {
        case AreasActions.SET_ALL_AREAS:
            return tassign( lastState, { all: action.payload } );
        case AreasActions.SET_SELETED_AREA:
            return tassign(lastState, { selected: action.payload });
        case AreasActions.CLEAR_AREAS:
            return tassign(lastState, AREAS_INITIAL_STATE);
    }
    // We don't care about any other actions right now.
    return lastState;
}
